"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationPill = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./AutomationPill.css"));
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var lodash_1 = require("lodash");
var AutomationPill = function (_a) {
    var integrationName = _a.integrationName, integrationDisplayName = _a.integrationDisplayName, disabled = _a.disabled;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.pill({ disabled: disabled }), direction: "horizontal", align: "center", gap: "xs" },
        disabled ? react_1.default.createElement(icons_1.QwilrGrayscale, null) : react_1.default.createElement(icons_1.Qwilr, null),
        react_1.default.createElement(icons_1.ChevronRight, { size: icons_1.IconSize.Small }),
        react_1.default.createElement(kaleidoscope_1.Tooltip, { content: integrationDisplayName }, getCrmIcon(integrationName, disabled))));
};
exports.AutomationPill = AutomationPill;
var getCrmIcon = function (integrationName, disabled) {
    var Icon = (disabled ? icons["".concat((0, lodash_1.capitalize)(integrationName), "Grayscale")] : icons[(0, lodash_1.capitalize)(integrationName)]) ||
        icons.Automation;
    return react_1.default.createElement(Icon, null);
};
